<script setup>
import { computed, inject } from "vue";
import { useI18n } from "vue-i18n";

const route = inject("route");
const { t } = useI18n();
</script>
<template>
  <div class="bg-primary">
    <div class="section-container">
      <div class="bg-white p-12 rounded-lg shadow-lg">
        <h2 class="text-4xl md:text-5xl text-center">{{ $t('Wat Maakt Zorgblik Uniek?') }}</h2>
        <div class="mt-10 grid md:grid-cols-4 gap-8">
          <div class="bg-[#d3f8f2] p-6 rounded-lg shadow-md text-left">
            <h3 class="text-xl font-semibold mb-3">{{ $t('Maatwerk Trajecten') }}</h3>
            <p
              class="text-lg text-gray-900"
            >{{ $t('Leer- en ontwikkeltrajecten afgestemd op de specifieke behoeften van zorgprofessionals en opdrachtgevers.') }}</p>
          </div>
          <div class="bg-[#d3f8f2] p-6 rounded-lg shadow-md text-left">
            <h3 class="text-xl font-semibold mb-3">{{ $t('Praktische toepassingen') }}</h3>
            <p
              class="text-lg text-gray-900"
            >{{ $t('Onze cursussen en trainingen zijn ontworpen om direct toepasbaar te zijn in de dagelijkse praktijk. We richten ons op realistische scenarios en praktische vaardigheden die je direct kunt gebruiken in je werk.') }}</p>
          </div>
          <div class="bg-[#d3f8f2] p-6 rounded-lg shadow-md text-left">
            <h3 class="text-xl font-semibold mb-3">{{ $t('Topkwaliteit Opleidingen') }}</h3>
            <p
              class="text-lg text-gray-900"
            >{{ $t('Samenwerking met de allerbeste aanbieders in de zorgsector.') }}</p>
          </div>
          <div class="bg-[#d3f8f2] p-6 rounded-lg shadow-md text-left">
            <h3 class="text-xl font-semibold mb-3">{{ $t('Deskundige trainers') }}</h3>
            <p
              class="text-lg text-gray-900"
            >{{ $t('Onze trainers zijn ervaren zorgprofessionals die hun kennis en expertise delen. Ze zijn gespecialiseerd in hun vakgebied en begeleiden je met geduld en enthousiasme.') }}</p>
          </div>
        </div>

        <p
          class="mt-2 text-lg md:text-xl mt-4"
        >{{ $t('Vooruitstrevend: Focus op zowel erkende zorgopleidingen als unieke trainingen voor maatschappelijke en werk gerelateerde uitdagingen.') }}</p>
      </div>
    </div>
  </div>
</template>